import { render } from "./TokenInfonNep11.vue?vue&type=template&id=515b3071"
import script from "./TokenInfonNep11.vue?vue&type=script&lang=js"
export * from "./TokenInfonNep11.vue?vue&type=script&lang=js"

import "./TokenInfonNep11.vue?vue&type=style&index=0&id=515b3071&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__